import Vue from 'vue';
import commonImageUploader from '../../../components/console-common/common-image-uploader.vue';
export default Vue.extend({
    name: 'fundLoanAppendix',
    props: {
        data: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    components: {
        'el-image-uploader': commonImageUploader,
    },
    data: function () {
        return {
            contractNote: '',
            fileList: [],
            imgData: {
                title: '',
                span: 24,
                fileList: [],
                key: 'accessories',
                type: 'check',
                disabled: true,
            },
        };
    },
    created: function () {
        this.init();
    },
    methods: {
        init: function () {
            var _this = this;
            var _a = this.data, capitalCode = _a.capitalCode, contractCode = _a.contractCode;
            this.$request({
                url: '/proxy/fund-api/capital/contract/appendix',
                method: 'post',
                data: {
                    capitalCode: capitalCode,
                    contractCode: contractCode,
                },
            }).then(function (res) {
                if (!res || res.errorCode !== 0) {
                    return;
                }
                var _a = res.data, contractNote = _a.contractNote, photos = _a.photos;
                _this.contractNote = contractNote;
                _this.imgData.fileList = photos;
            });
        },
    },
});
